import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'eva-tag',
    template: `
        <span class="eva-3-tag tag-container" 
          [ngClass]="{
            '-active': active, 
            '-lighten': variant === 'LIGHTEN', 
            '-no-cross-icon': !showCrossIcon}"
          >
            <span class="tag-text" (click)="clickEvent.emit()">
              {{text}}
              <i *ngIf="showIcon()" class="-eva-3-pl-xsm -eva-3-icon-xsm eva-3-icon-{{icon}}"></i>
            </span>
            <i *ngIf="showCrossIcon" class="eva-3-icon-cross tag-icon" (click)="removeEvent.emit()"></i>
        </span>
    `,
    styleUrls: ['./eva-tag.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class EvaTagComponent {
  @Input() text: string;
  @Input() active: boolean;
  @Input() icon: string = '';
  @Input() variant: 'DEFAULT' | 'LIGHTEN' = 'DEFAULT';
  @Input() showCrossIcon: boolean = true;
  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() removeEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  showIcon(): boolean {
    return this.icon != '' && !this.active;
  }
}
